import { createContext, useContext } from 'react';

const ClientContext = createContext(undefined); // Important for validation

export const useClientContext = () => {
  const context = useContext(ClientContext);
  if (context === undefined) {
    throw new Error("useClientContext must be used within a ClientProvider");
  }
  return context;
};

export const ClientProvider = ({ client, children }) => (
  <ClientContext.Provider value={{ client }}>
    {children}
  </ClientContext.Provider>
);
